var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "arrow-link",
      attrs: { href: _vm.href },
      on: { click: _vm.onClick }
    },
    [
      _c("Icon", {
        attrs: {
          icon: "triangle-right",
          color: "red",
          rotate: _vm.arrowDown ? 90 : 0
        }
      }),
      _vm._v(" " + _vm._s(_vm.text) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }